import { MaterialCommunityIcons } from '@expo/vector-icons';
import { ILogger, normalizeUrl, useGrippContext } from '@gripp/shared-logic';
import { useCallback } from 'react';
import { Linking, StyleSheet } from 'react-native';
import { Card } from 'react-native-paper';
import { Colors } from '../../themes/colors';
import { LinkData, MediaComponent, MediaComponentProps } from './types';

export const LinkComponent: MediaComponent<LinkData> = ({
  displayMode = 'card',
  displayWidth = 80,
  onPress,
  ...props
}: MediaComponentProps<LinkData>) => {
  const { logger } = useGrippContext();
  const linkCardStyle =
    displayMode === 'card' ? styles.linkThumbCard : styles.linkOutlinedCard;

  const handlePress = useCallback(() => {
    if (onPress) {
      onPress();
      return;
    }
    openLink(props.mediaItem.url, logger);
  }, [props.mediaItem.url, logger, onPress]);

  return (
    <Card
      onPress={handlePress}
      mode={displayMode === 'outlined' ? 'outlined' : 'elevated'}
      style={[
        styles.baseCard,
        linkCardStyle,
        { width: displayWidth, height: displayWidth },
      ]}
    >
      <Card.Content style={styles.cardContent}>
        <MaterialCommunityIcons
          name={'link'}
          color={Colors.primaryDark}
          size={displayWidth * 0.4}
        />
      </Card.Content>
    </Card>
  );
};

const openLink = async (url: string, logger?: ILogger) => {
  try {
    const normalizedUrl = normalizeUrl(url);
    const supported = await Linking.canOpenURL(normalizedUrl);

    if (supported) {
      await Linking.openURL(normalizedUrl);
    } else {
      logger?.error(`Cannot open URL: ${normalizedUrl}`);
    }
  } catch (error) {
    logger?.error(error, `Failed to open link: ${url}`);
  }
};

const styles = StyleSheet.create({
  baseCard: {
    borderRadius: 8,
    backgroundColor: Colors.secondaryGrayHeader,
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContent: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: 0,
    margin: 0,
  },
  linkThumbCard: {},
  linkOutlinedCard: {
    borderWidth: 0.5,
    borderColor: Colors.grayDivider,
  },
});
